(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9789],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 62816:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NewsTag; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var NewsTag = function NewsTag(tag) {
  var tagColor = tag.code === 'importantNotices' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.red */ .r.colors.red : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Tag, {
    color: tagColor,
    children: tag.name
  });
};
var Tag = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].li.withConfig */ .ZP.li.withConfig({
  displayName: "NewsTag__Tag",
  componentId: "sc-1gokp8z-0"
})(["font-size:13px;text-align:center;line-height:1;color:", ";list-style:none;min-width:82px;padding:6px 13px;border:1pt solid;border-radius:2pt;border-color:", ";color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue, function (_ref) {
  var color = _ref.color;
  return color;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
});

/***/ }),

/***/ 99903:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ NewsTagButton; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["tag", "isActive", "size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var NewsTagButton = function NewsTagButton(_ref) {
  var tag = _ref.tag,
      isActive = _ref.isActive,
      size = _ref.size,
      props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  var tagColor = tag.code === 'importantNotices' ? _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.red */ .r.colors.red : _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(TagButton, _objectSpread(_objectSpread({
    type: "button",
    "aria-pressed": isActive,
    color: tagColor,
    size: size
  }, props), {}, {
    children: tag.name
  }));
};
var SmallButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["font-size:13px;letter-spacing:0;line-height:23px;padding:0 28px;height:25px;"]);
var RegularButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_4__/* .css */ .iv)(["font-size:16px;line-height:27px;padding:0 18px;height:36px;@media screen and (max-width:1047px){height:34px;font-size:14px;line-height:24px;}"]);
var TagButton = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "NewsTagButton__TagButton",
  componentId: "sc-rtr6u2-0"
})(["", ";border:", ";border-radius:2px;cursor:pointer;transition:0.3s;color:", ";background-color:#ffffff;&[disabled]{cursor:default;}@media (hover:hover){&:hover{opacity:0.6;}}&[aria-pressed='true']{color:#ffffff;background-color:", ";}"], function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? SmallButton : RegularButton;
}, function (_ref3) {
  var color = _ref3.color;
  return "1px solid ".concat(color);
}, function (_ref4) {
  var color = _ref4.color;
  return color;
}, function (_ref5) {
  var color = _ref5.color;
  return color;
});

/***/ }),

/***/ 63279:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Pagination; }
});

// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
;// CONCATENATED MODULE: ./src/utils/number.ts



var _marked = /*#__PURE__*/regenerator_default().mark(rangeGenerator);

function rangeGenerator(start, end) {
  var interval,
      i,
      _args = arguments;
  return regenerator_default().wrap(function rangeGenerator$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          interval = _args.length > 2 && _args[2] !== undefined ? _args[2] : 1;
          i = start;

        case 2:
          if (!(i <= end)) {
            _context.next = 8;
            break;
          }

          _context.next = 5;
          return i;

        case 5:
          i += interval;
          _context.next = 2;
          break;

        case 8:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
/**
 * 指定した範囲の配列を生成する
 */


var range = function range(start, end) {
  var interval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (0,toConsumableArray/* default */.Z)(rangeGenerator(start, end, interval));
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Pagination/PaginationButton.tsx


var _excluded = ["page", "isActive"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PaginationButton = function PaginationButton(_ref) {
  var page = _ref.page,
      isActive = _ref.isActive,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (page === 'next') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButton, _objectSpread(_objectSpread({
        type: "button"
      }, props), {}, {
        "aria-label": "\u6B21\u306E\u30DA\u30FC\u30B8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(NextIcon, {})
      }))
    });
  }

  if (page === 'before') {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(ArrowButton, _objectSpread(_objectSpread({
        type: "button"
      }, props), {}, {
        "aria-label": "\u524D\u306E\u30DA\u30FC\u30B8",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(BeforeIcon, {})
      }))
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Button, _objectSpread(_objectSpread({
      type: "button",
      "aria-current": isActive ? 'page' : undefined
    }, props), {}, {
      children: page
    }))
  });
};
var Button = styled_components_browser_esm/* default.button.withConfig */.ZP.button.withConfig({
  displayName: "PaginationButton__Button",
  componentId: "sc-1ianbpk-0"
})(["display:grid;place-content:center;width:46px;height:44px;font-size:16px;line-height:27px;border:1px solid ", ";background-color:#ffffff;color:", ";border-radius:2px;cursor:pointer;transition:all 0.3s ease-out;&:hover{background-color:", ";color:#ffffff;> svg{color:#ffffff;}}&[aria-current='page']{background-color:", ";color:#ffffff;cursor:initial;pointer-events:none;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var ArrowButton = (0,styled_components_browser_esm/* default */.ZP)(Button).withConfig({
  displayName: "PaginationButton__ArrowButton",
  componentId: "sc-1ianbpk-1"
})(["display:grid;place-content:center;"]);
var NextIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdNavigateNext */.sOJ).withConfig({
  displayName: "PaginationButton__NextIcon",
  componentId: "sc-1ianbpk-2"
})(["color:", ";font-size:22px;"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var BeforeIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdNavigateBefore */.D68).withConfig({
  displayName: "PaginationButton__BeforeIcon",
  componentId: "sc-1ianbpk-3"
})(["color:", ";font-size:22px;"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
;// CONCATENATED MODULE: ./src/components/elements/Pagination/index.tsx








var MAX_DISPLAY_COUNT = 5;

var createPageList = function createPageList(currentPage, totalPageCount) {
  // 5ページ未満
  if (totalPageCount < MAX_DISPLAY_COUNT) {
    return range(1, totalPageCount);
  } // 最初の2ページ


  if (currentPage < 3) {
    var end = Math.min(MAX_DISPLAY_COUNT, totalPageCount);
    return range(1, end);
  } // 最後の2ページ


  if (currentPage > totalPageCount - 3) {
    return range(totalPageCount - (MAX_DISPLAY_COUNT - 1), totalPageCount);
  }

  return range(currentPage - 2, currentPage + 2);
};

var Pagination = function Pagination(_ref) {
  var totalCount = _ref.totalCount,
      countPerPage = _ref.countPerPage,
      currentPage = _ref.currentPage,
      transitionPage = _ref.transitionPage;

  if (totalCount === 0) {
    return null;
  }

  var lastPage = Math.ceil(totalCount / countPerPage);
  var pageList = createPageList(currentPage, lastPage);
  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage === lastPage;
  var isIncludeFirstPage = pageList[0] === 1;
  var isIncludeLastPage = pageList.at(-1) === lastPage;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("nav", {
    "aria-label": "\u30DA\u30FC\u30B8\u30CD\u30FC\u30B7\u30E7\u30F3",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(List, {
      children: [!isFirstPage && /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
        page: "before",
        onClick: function onClick() {
          return transitionPage(function (prev) {
            return prev - 1;
          });
        }
      }), !isIncludeFirstPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: 1,
          onClick: function onClick() {
            return transitionPage(1);
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Ellipsis, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EllipsisIcon, {})
        })]
      }), pageList.map(function (page) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: page,
          isActive: page === currentPage,
          onClick: function onClick() {
            return transitionPage(page);
          }
        }, page);
      }), !isIncludeLastPage && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Ellipsis, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(EllipsisIcon, {})
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
          page: lastPage,
          onClick: function onClick() {
            return transitionPage(lastPage);
          }
        })]
      }), !isLastPage && /*#__PURE__*/(0,jsx_runtime.jsx)(PaginationButton, {
        page: "next",
        onClick: function onClick() {
          return transitionPage(function (prev) {
            return prev + 1;
          });
        }
      })]
    })
  });
};
var List = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "Pagination__List",
  componentId: "sc-5bez2-0"
})(["display:flex;flex-wrap:wrap;justify-content:center;gap:14px;@media screen and (max-width:1047px){gap:8px;}"]);
var Ellipsis = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Pagination__Ellipsis",
  componentId: "sc-5bez2-1"
})(["display:grid;place-content:center;margin:0 10px;@media screen and (max-width:1047px){margin:0 5px;}"]);
var EllipsisIcon = (0,styled_components_browser_esm/* default */.ZP)(index_esm/* MdMoreHoriz */.xr$).withConfig({
  displayName: "Pagination__EllipsisIcon",
  componentId: "sc-5bez2-2"
})(["color:", ";"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 76917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4730);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


var _excluded = ["name", "options"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var Select = function Select(_ref) {
  var name = _ref.name,
      options = _ref.options,
      props = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_ref, _excluded);

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(SelectWrapper, _objectSpread(_objectSpread({
    name: name
  }, props), {}, {
    children: options.map(function (_ref2) {
      var value = _ref2.value,
          text = _ref2.text;
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("option", {
        value: value,
        children: text
      }, value);
    })
  }));
};
var SelectWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].select.withConfig */ .ZP.select.withConfig({
  displayName: "Select__SelectWrapper",
  componentId: "sc-u4d6wg-0"
})(["appearance:none;font-size:16px;line-height:27px;letter-spacing:0;height:36px;width:144px;padding-left:18px;cursor:pointer;color:", ";background-color:#ffffff;border:1px solid ", ";border-radius:2px;background-image:linear-gradient( to left bottom,", " 50%,transparent 50% ),linear-gradient( to right bottom,", " 50%,transparent 50% );background-size:7px 10px,7px 10px;background-position:calc(100% - 25px) 50%,calc(100% - 18px) 50%;background-repeat:no-repeat;"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 81187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ AccordionFilter; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5434);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var AccordionFilter = function AccordionFilter(_ref) {
  var children = _ref.children;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false),
      isExpand = _useState[0],
      setIsExpand = _useState[1];

  var id = (0,react__WEBPACK_IMPORTED_MODULE_0__.useId)();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(Button, {
      type: "button",
      onClick: function onClick() {
        return setIsExpand(function (prev) {
          return !prev;
        });
      },
      "aria-expanded": isExpand,
      "aria-controls": id,
      children: ["\u7D5E\u308A\u8FBC\u307F", isExpand ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CloseIcon, {}) : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(OpenIcon, {})]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(Content, {
      id: id,
      children: children
    })]
  });
};
var Button = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].button.withConfig */ .ZP.button.withConfig({
  displayName: "AccordionFilter__Button",
  componentId: "sc-111r906-0"
})(["display:none;@media screen and (max-width:1047px){width:100%;height:50px;padding:0 22px;display:flex;align-items:center;justify-content:space-between;font-size:16px;font-weight:bold;color:", ";background-color:", ";border:none;border-radius:8px;&[aria-expanded='true']{border-bottom-left-radius:0;border-bottom-right-radius:0;}&[aria-expanded='false'] + div{height:0;padding-top:0;padding-bottom:0;opacity:0;overflow:hidden;pointer-events:none;}}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.textTitle */ .r.colors.textTitle, _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var Content = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "AccordionFilter__Content",
  componentId: "sc-111r906-1"
})(["display:flex;flex-direction:column;gap:26px;background-color:", ";padding:46px 72px;border-radius:8px;@media screen and (max-width:1047px){transition:0.3s;padding:26px 22px;gap:24px;border-top-right-radius:0;border-top-left-radius:0;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.backgroundGrey */ .r.colors.backgroundGrey);
var OpenIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdAdd */ .x06).withConfig({
  displayName: "AccordionFilter__OpenIcon",
  componentId: "sc-111r906-2"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);
var CloseIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(react_icons_md__WEBPACK_IMPORTED_MODULE_4__/* .MdRemove */ .eqC).withConfig({
  displayName: "AccordionFilter__CloseIcon",
  componentId: "sc-111r906-3"
})(["font-size:30px;color:", ";"], _styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .theme.colors.grey */ .r.colors.grey);

/***/ }),

/***/ 58154:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ FilterField; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var FilterField = function FilterField(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Field, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Title, {
      children: title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(FilterList, {
      children: children
    })]
  });
};
var Field = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FilterField__Field",
  componentId: "sc-1sa9tdf-0"
})(["display:flex;align-items:center;@media screen and (max-width:1047px){flex-direction:column;align-items:flex-start;gap:20px;}"]);
var Title = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FilterField__Title",
  componentId: "sc-1sa9tdf-1"
})(["font-size:16px;line-height:27px;color:", ";width:48px;margin-right:80px;@media screen and (max-width:1047px){font-size:14px;line-height:24px;margin:0;width:auto;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle);
var FilterList = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "FilterField__FilterList",
  componentId: "sc-1sa9tdf-2"
})(["display:flex;flex-wrap:wrap;gap:18px;flex:1;"]);

/***/ }),

/***/ 97818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ monthOptions; },
/* harmony export */   "S4": function() { return /* binding */ getYearList; },
/* harmony export */   "hP": function() { return /* binding */ getYearOptions; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16645);


var getYearList = function getYearList(list) {
  var yearList = (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Set(list.map(function (_ref) {
    var publishDate = _ref.publishDate;
    return (0,_utils_date__WEBPACK_IMPORTED_MODULE_1__/* .formatDate */ .p6)(publishDate, 'yyyy');
  })));

  yearList.sort(function (a, b) {
    return Number(b) - Number(a);
  });
  return yearList;
};
var getYearOptions = function getYearOptions(list) {
  var yearList = getYearList(list);
  var yearOptions = yearList.map(function (y) {
    return {
      value: y,
      text: "".concat(y, "\u5E74")
    };
  });
  return [{
    value: '',
    text: 'すべての年'
  }].concat((0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(yearOptions));
};
var monthOptions = [{
  value: '',
  text: 'すべての月'
}, {
  value: '1',
  text: '1月'
}, {
  value: '2',
  text: '2月'
}, {
  value: '3',
  text: '3月'
}, {
  value: '4',
  text: '4月'
}, {
  value: '5',
  text: '5月'
}, {
  value: '6',
  text: '6月'
}, {
  value: '7',
  text: '7月'
}, {
  value: '8',
  text: '8月'
}, {
  value: '9',
  text: '9月'
}, {
  value: '10',
  text: '10月'
}, {
  value: '11',
  text: '11月'
}, {
  value: '12',
  text: '12月'
}];

/***/ }),

/***/ 14156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ useFadeTransition; }
/* harmony export */ });
/* harmony import */ var _workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_transition_group__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29667);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




var useFadeTransition = function useFadeTransition(duration) {
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false),
      inProp = _useState[0],
      setInProp = _useState[1];

  var nodeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  /**
   * トランジションが発生してから関数を実行させる
   */

  var transitionFn = function transitionFn(fn) {
    setInProp(true);
    setTimeout(function () {
      fn();
    }, duration);
  };

  var render = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function (_children) {
    var defaultStyle = {
      transition: "opacity ".concat(duration, "ms cubic-bezier(0.55, 0.085, 0.68, 0.53)"),
      opacity: 1
    };
    var transitionStyle = {
      entering: {
        opacity: 0
      },
      entered: {
        opacity: 1
      },
      exiting: {
        opacity: 1
      },
      exited: {
        opacity: 1
      },
      unmounted: {
        opacity: 0
      }
    };
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_transition_group__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
      nodeRef: nodeRef,
      "in": inProp,
      timeout: duration,
      onEntered: function onEntered() {
        return setInProp(false);
      },
      children: function children(state) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
          ref: nodeRef,
          style: _objectSpread(_objectSpread({}, defaultStyle), transitionStyle[state]),
          children: _children
        });
      }
    });
  }, [duration, inProp, nodeRef]);
  return {
    render: render,
    transitionFn: transitionFn
  };
};

/***/ }),

/***/ 95710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ ExposurePage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/Line/index.tsx
var Line = __webpack_require__(9945);
// EXTERNAL MODULE: ./src/components/elements/News/NewsTagButton/index.tsx
var NewsTagButton = __webpack_require__(99903);
// EXTERNAL MODULE: ./src/components/elements/Select/index.tsx
var Select = __webpack_require__(76917);
// EXTERNAL MODULE: ./src/components/pages/News/AccordionFilter.tsx
var AccordionFilter = __webpack_require__(81187);
// EXTERNAL MODULE: ./src/components/pages/News/dateOptions.ts
var dateOptions = __webpack_require__(97818);
// EXTERNAL MODULE: ./src/components/pages/News/FilterField.tsx
var FilterField = __webpack_require__(58154);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/News/Exposure/Filter.tsx








var Filter = function Filter(_ref) {
  var mediaTypeList = _ref.mediaTypeList,
      selectedTags = _ref.selectedTags,
      yearOptions = _ref.yearOptions,
      changeSelectedYear = _ref.changeSelectedYear,
      changeSelectedMonth = _ref.changeSelectedMonth,
      changeSelectedTag = _ref.changeSelectedTag,
      handleAllTags = _ref.handleAllTags;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(AccordionFilter/* AccordionFilter */.C, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(FilterField/* FilterField */.R, {
      title: "\u516C\u958B\u65E5",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
        name: "year",
        "aria-label": "\u516C\u958B\u5E74",
        defaultValue: "",
        options: yearOptions,
        onChange: changeSelectedYear
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Select/* Select */.P, {
        name: "month",
        "aria-label": "\u516C\u958B\u6708",
        defaultValue: "",
        options: dateOptions/* monthOptions */.EN,
        onChange: changeSelectedMonth
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Line/* Line */.x, {
      color: "grey",
      weight: 1,
      direction: "horizon"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(FilterField/* FilterField */.R, {
      title: "\u5A92\u4F53",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NewsTagButton/* NewsTagButton */.j, {
        tag: {
          name: 'すべて',
          code: 'all'
        },
        isActive: selectedTags.length === 0,
        onClick: handleAllTags,
        disabled: selectedTags.length === 0
      }), mediaTypeList.map(function (tag) {
        var _selectedTags$include;

        return /*#__PURE__*/(0,jsx_runtime.jsx)(NewsTagButton/* NewsTagButton */.j, {
          tag: {
            name: tag,
            code: tag
          },
          isActive: (_selectedTags$include = selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.includes(tag)) !== null && _selectedTags$include !== void 0 ? _selectedTags$include : false,
          onClick: function onClick() {
            return changeSelectedTag(tag);
          }
        }, tag);
      })]
    })]
  });
};
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(16645);
;// CONCATENATED MODULE: ./src/components/pages/News/Exposure/useExposureList.ts



var useExposureList = function useExposureList(mediaExposureList, countPerPage) {
  var _useState = (0,react.useState)(''),
      selectedYear = _useState[0],
      setSelectedYear = _useState[1];

  var _useState2 = (0,react.useState)(''),
      selectedMonth = _useState2[0],
      setSelectedMonth = _useState2[1];

  var _useState3 = (0,react.useState)([]),
      selectedTags = _useState3[0],
      setSelectedTags = _useState3[1];

  var _useState4 = (0,react.useState)(1),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var filteredMediaList = (0,react.useMemo)(function () {
    return mediaExposureList.filter(function (_ref) {
      var mediaType = _ref.mediaType,
          publishDate = _ref.publishDate;
      var yearFilter = selectedYear ? (0,date/* isEqualYear */.bp)(publishDate, selectedYear) : true;
      var monthFilter = selectedMonth ? (0,date/* isEqualMonth */.dG)(publishDate, selectedMonth) : true;
      var tagFilter = selectedTags.length > 0 ? selectedTags.includes(mediaType.type) : true;
      return yearFilter && monthFilter && tagFilter;
    });
  }, [mediaExposureList, selectedMonth, selectedTags, selectedYear]);
  var displayMediaList = (0,react.useMemo)(function () {
    var start = countPerPage * (currentPage - 1);
    var end = start + countPerPage;
    var list = filteredMediaList.slice(start, filteredMediaList.length < end ? undefined : end);
    return list;
  }, [currentPage, filteredMediaList, countPerPage]);
  var changeSelectedYear = (0,react.useCallback)(function (event) {
    setSelectedYear(event.target.value);
    setCurrentPage(1);
  }, []);
  var changeSelectedMonth = (0,react.useCallback)(function (event) {
    setSelectedMonth(event.target.value);
    setCurrentPage(1);
  }, []);
  var changeSelectedTag = (0,react.useCallback)(function (text) {
    setSelectedTags(function (currentTags) {
      if (!currentTags) {
        return [text];
      }

      if (currentTags.includes(text)) {
        return currentTags.filter(function (tag) {
          return tag !== text;
        });
      }

      return [].concat((0,toConsumableArray/* default */.Z)(currentTags), [text]);
    });
    setCurrentPage(1);
  }, []);
  var transitionPage = (0,react.useCallback)(function (value) {
    setCurrentPage(value);
    window.scrollTo({
      top: 0
    });
  }, []);
  var handleAllTags = (0,react.useCallback)(function () {
    setSelectedTags([]);
    setCurrentPage(1);
  }, []);
  return {
    selectedTags: selectedTags,
    displayMediaList: displayMediaList,
    totalCount: filteredMediaList.length,
    currentPage: currentPage,
    changeSelectedYear: changeSelectedYear,
    changeSelectedMonth: changeSelectedMonth,
    changeSelectedTag: changeSelectedTag,
    transitionPage: transitionPage,
    handleAllTags: handleAllTags
  };
};
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/elements/News/MediaItem/Container.tsx



var Container = function Container(_ref) {
  var url = _ref.url,
      children = _ref.children;

  if (url) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(Anchor, {
      href: url,
      target: "_blank",
      rel: "noreferrer noopener",
      children: children
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(Div, {
    children: children
  });
};
var Div = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Container__Div",
  componentId: "sc-109oq2o-0"
})(["display:flex;flex-direction:column;gap:12px;color:", ";@media screen and (max-width:1047px){row-gap:20px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var Anchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "Container__Anchor",
  componentId: "sc-109oq2o-1"
})(["display:flex;flex-direction:column;gap:12px;cursor:pointer;> h3{color:", ";text-decoration:underline;transition:color 0.3s ease-out;}&:hover > h3{color:", ";> svg{fill:", ";}}@media screen and (max-width:1047px){row-gap:20px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.hover */.r.colors.hover, theme/* theme.colors.hover */.r.colors.hover);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/News/NewsTag/index.tsx
var NewsTag = __webpack_require__(62816);
;// CONCATENATED MODULE: ./src/components/elements/News/MediaItem/index.tsx








var MediaItem = function MediaItem(_ref) {
  var name = _ref.name,
      mediaType = _ref.mediaType,
      company = _ref.company,
      publishDate = _ref.publishDate,
      content = _ref.content,
      url = _ref.url;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Article, {
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
      url: url,
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeadSection, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
          dateTime: publishDate,
          children: (0,date/* formatDate */.p6)(publishDate, 'yyyy/MM/dd')
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(TagList, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(NewsTag/* NewsTag */.a, {
            name: mediaType.type,
            code: mediaType.code
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MediaInfo, {
          children: [name, "\uFF0F", company]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Title, {
        children: [content, url && /*#__PURE__*/(0,jsx_runtime.jsx)(ExternalLink/* ExternalLinkIcon */.h, {
          size: "small"
        })]
      })]
    })
  });
};
var Article = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
  displayName: "MediaItem__Article",
  componentId: "sc-110c4hl-0"
})(["padding-bottom:30px;:not(:last-of-type){border-bottom:1px solid ", ";}@media screen and (max-width:1047px){padding-bottom:26px;}"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
var HeadSection = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MediaItem__HeadSection",
  componentId: "sc-110c4hl-1"
})(["display:flex;align-items:center;flex-wrap:wrap;gap:6px 20px;"]);
var Time = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "MediaItem__Time",
  componentId: "sc-110c4hl-2"
})(["font-size:16px;font-weight:bold;line-height:26px;letter-spacing:0.64px;color:", ";"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var MediaInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MediaItem__MediaInfo",
  componentId: "sc-110c4hl-3"
})(["font-size:16px;line-height:26px;letter-spacing:0.64px;color:", ";"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var TagList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "MediaItem__TagList",
  componentId: "sc-110c4hl-4"
})(["display:flex;flex-wrap:wrap;gap:12px;"]);
var Title = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "MediaItem__Title",
  componentId: "sc-110c4hl-5"
})(["font-size:18px;font-weight:bold;letter-spacing:0.72px;line-height:26px;color:", ";> svg{margin-left:8px;}@media screen and (max-width:1047px){font-size:15px;line-height:25px;letter-spacing:1.5px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
// EXTERNAL MODULE: ./src/components/elements/Pagination/index.tsx + 2 modules
var Pagination = __webpack_require__(63279);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/hooks/useFadeTransition.tsx
var useFadeTransition = __webpack_require__(14156);
;// CONCATENATED MODULE: ./src/components/pages/News/Exposure/MediaList.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }












var MediaList = function MediaList(_ref) {
  var mediaExposureList = _ref.mediaExposureList,
      mediaTypeList = _ref.mediaTypeList;
  var COUNT_PER_PAGE = 30;

  var _useExposureList = useExposureList(mediaExposureList, COUNT_PER_PAGE),
      selectedTags = _useExposureList.selectedTags,
      displayMediaList = _useExposureList.displayMediaList,
      currentPage = _useExposureList.currentPage,
      totalCount = _useExposureList.totalCount,
      _changeSelectedYear = _useExposureList.changeSelectedYear,
      _changeSelectedMonth = _useExposureList.changeSelectedMonth,
      _changeSelectedTag = _useExposureList.changeSelectedTag,
      _transitionPage = _useExposureList.transitionPage,
      handleAllTags = _useExposureList.handleAllTags;

  var _useFadeTransition = (0,useFadeTransition/* useFadeTransition */.W)(300),
      render = _useFadeTransition.render,
      transitionFn = _useFadeTransition.transitionFn;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Filter, {
      selectedTags: selectedTags,
      mediaTypeList: mediaTypeList,
      yearOptions: (0,dateOptions/* getYearOptions */.hP)(mediaExposureList),
      changeSelectedYear: function changeSelectedYear(e) {
        return transitionFn(function () {
          return _changeSelectedYear(e);
        });
      },
      changeSelectedMonth: function changeSelectedMonth(e) {
        return transitionFn(function () {
          return _changeSelectedMonth(e);
        });
      },
      changeSelectedTag: function changeSelectedTag(text) {
        return transitionFn(function () {
          return _changeSelectedTag(text);
        });
      },
      handleAllTags: handleAllTags
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 40,
        pc: 80
      }
    }), render( /*#__PURE__*/(0,jsx_runtime.jsx)(List, {
      children: displayMediaList.length > 0 ? displayMediaList.map(function (item) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)(MediaItem, _objectSpread({}, item), item._id);
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Message, {
        children: "\u4E00\u81F4\u3059\u308B\u60C5\u5831\u304C\u307F\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F"
      })
    })), totalCount > 0 && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 47,
          pc: 77
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Pagination/* Pagination */.t, {
        totalCount: totalCount,
        countPerPage: COUNT_PER_PAGE,
        currentPage: currentPage,
        transitionPage: function transitionPage(page) {
          return transitionFn(function () {
            return _transitionPage(page);
          });
        }
      })]
    })]
  });
};
var List = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MediaList__List",
  componentId: "sc-agy8kc-0"
})(["display:flex;flex-direction:column;gap:24px;"]);
var Message = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "MediaList__Message",
  componentId: "sc-agy8kc-1"
})(["font-size:16px;letter-spacing:0.64px;line-height:26px;@media screen and (max-width:1047px){font-size:15px;line-height:24px;letter-spacing:0;}"]);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/News/Exposure/index.tsx


function Exposure_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function Exposure_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { Exposure_ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { Exposure_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }










var ExposurePage = function ExposurePage(_ref) {
  var mediaExposureList = _ref.mediaExposureList,
      mediaTypeList = _ref.mediaTypeList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      titleText: "Media Exposure List",
      subTitleText: "\u30E1\u30C7\u30A3\u30A2\u9732\u51FA\u4E00\u89A7",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 50,
        pc: 50
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(MediaList, {
      mediaExposureList: mediaExposureList,
      mediaTypeList: mediaTypeList
    })]
  });
};

ExposurePage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: 'ニュースルーム',
    path: '/news/'
  }, {
    name: 'メディア露出一覧',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u30E1\u30C7\u30A3\u30A2\u9732\u51FA\u4E00\u89A7",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u304C\u63B2\u8F09\u3055\u308C\u305F\u65B0\u805E\u8A18\u4E8B\u3001\u30C6\u30EC\u30D3\u756A\u7D44\u3001\u96D1\u8A8C\u306A\u3069\u306E\u30E1\u30C7\u30A3\u30A2\u30B3\u30F3\u30C6\u30F3\u30C4\u3092\u30EA\u30B9\u30C8\u30A2\u30C3\u30D7\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: 'news/exposure/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, Exposure_objectSpread(Exposure_objectSpread({}, pageTitle), {}, {
      breadCrumbs: breadCrumbs,
      children: page
    }))]
  });
};

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Exposure__Wrapper",
  componentId: "sc-8utw5v-0"
})(["width:1045px;margin:0 auto;padding:70px 0 130px;@media screen and (max-width:1047px){width:100%;padding:40px 20px 80px;}"]);
;// CONCATENATED MODULE: ./src/pages/news/exposure.tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 55252:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/exposure",
      function () {
        return __webpack_require__(95710);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5716,5548,9774,2888,179], function() { return __webpack_exec__(55252); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);